import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDarkMode } from '../hooks/useDarkMode'

export default function ForgetPassword() {
  const { isDarkMode } = useDarkMode();
  const [email, setEmail] = useState('');
  const [focused, setFocused] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const maskEmail = (e) => {
    if (!e) return 'your email';
    const parts = e.split('@');
    if (parts.length !== 2) return e;
    const name = parts[0];
    const domain = parts[1];
    if (name.length <= 2) return name + '@' + domain;
    return name.slice(0, 3) + '****@' + domain;
  };

  const isValidEmail = (v) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(v);
  };

  const handleGetCode = async () => {
    setError('');
    if (!isValidEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    try {
      const { sendOtpApi } = await import('../apis/auth.api');
      await sendOtpApi(email);
      navigate('/otpverify', { state: { email } });
    } catch (e) {
      setError(e?.error || e?.message || 'Failed to send code. Please try again.');
    }
  };

  return (
    <div className={`min-h-screen flex items-center justify-center p-4 ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      {/* ===== BACKGROUND CIRCLES ===== */}
      <div className="absolute -top-24 -left-24 w-72 h-72 bg-[#008300]/10 rounded-full"></div>
      <div className="absolute top-40 right-0 w-64 h-64 bg-[#0B1B3F]/10 rounded-full"></div>
      <div className={`w-full max-w-md rounded-2xl shadow-md p-8 ${isDarkMode ? 'bg-gray-800 text-gray-200' : 'bg-white text-gray-900'}`}>
        <h2 className="text-2xl font-bold mb-6 text-center">Forget Password</h2>
        <p className={`mb-6 text-center ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
          A mail with five-digits verification code will be sent to {email ? <strong>{maskEmail(email)}</strong> : <strong>****@****</strong>}
        </p>

        <div className="mb-4">
          <div className="relative">
            <input
              type="text"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              placeholder=" "
              className={`peer w-full px-4 py-3 outline-2 rounded-lg focus:outline-[#008300] focus:ring-0 ${isDarkMode ? 'bg-gray-700 text-gray-200 placeholder-gray-400' : 'bg-gray-200 text-gray-900 placeholder-gray-500'}`}
            />
            <label
              className={`absolute left-3 transition-all pointer-events-none ${email || focused ? '-top-2.5 text-xs text-white bg-transparent px-1' : 'text-gray-500 top-3'} ${isDarkMode ? 'text-gray-300' : ' text-gray-500'}`}
            >
              Enter your email
            </label>
          </div>
          {error && <p className="text-sm text-red-500 mt-2">{error}</p>}
        </div>

        <button onClick={handleGetCode} className="w-full bg-[#008300] text-white py-2 rounded-md font-semibold hover:bg-[#006600] transition">
          Get Code
        </button>

        <p className={`text-center text-sm mt-4 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
          Having a problem?{' '}
          <button className="text-[#008300] font-semibold hover:underline">Resend now</button>
        </p>
      </div>
    </div>
  );
}
